import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React from 'react';
import CheckboxValueGroup from '../../components/CheckboxValueGroup/CheckboxValueGroup';
import { GridRendererProps } from '../../components/Grid/Grid';
import RadioButtonValueGroup from '../../components/RadioButtonValueGroup/RadioButtonValueGroup';
import { useStore } from '../../hooks/use-store';
import {
  AutomatedPopupsValues,
  ManualButtonsValues,
  PracticeOffersResponse,
} from '../../types/practices-types';

export const AutomatedPopupsRenderer = observer(
  (props: GridRendererProps<PracticeOffersResponse>) => {
    const { row, index } = props;
    const store = useStore().offerSetupStore;

    return (
      <RadioButtonValueGroup
        id={`practice-automated-popups-group-${index}`}
        elementsClass={`practice-automated-popups-group-${index}`}
        variant='horizontal'
        values={AutomatedPopupsValues}
        onChange={idx =>
          runInAction(() => {
            row.automatedPopups = AutomatedPopupsValues[idx];
            store.hasUnsavedChanges = true;
          })
        }
        checkedIndex={AutomatedPopupsValues.findIndex(v => v === row.automatedPopups)}
      />
    );
  },
);

export const ManualButtonRenderer = observer((props: GridRendererProps<PracticeOffersResponse>) => {
  const { row, index } = props;
  const store = useStore().offerSetupStore;
  const changeIndices = (
    indices: number[],
    addedIndex: number | undefined,
    removedIndex: number | undefined,
  ): void => {
    runInAction(() => {
      if (addedIndex === 0) row.manualButtons = [...ManualButtonsValues];
      else if (removedIndex === 0) row.manualButtons = [];
      else row.manualButtons = indices.map(idx => ManualButtonsValues[idx]);
      store.hasUnsavedChanges = true;
    });
  };

  const isDisabled = (idx: number): boolean => {
    if (ManualButtonsValues[idx] === 'All') {
      return !row.manualButtons.includes('All') && row.manualButtons.some(v => v !== 'All');
    }
    return row.manualButtons.includes('All');
  };

  return (
    <CheckboxValueGroup
      id={`practices-manual-buttons-group-${index}`}
      elementsClass='manual-buttons-editors'
      variant='horizontal'
      values={ManualButtonsValues}
      onChange={changeIndices}
      checkedIndices={row.manualButtons.map(v => ManualButtonsValues.findIndex(bv => bv === v))}
      disabledByIndex={i => isDisabled(i)}
    />
  );
});
